import anvilTheme from "./anvilStyles";

export default {
    ...anvilTheme.fonts
}
